export const addWatermark = (html: string, watermarkText: string) => `
  <div style="
      position: fixed;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(-30deg);
      font-size: 5rem;
      color: rgba(0, 0, 0, 0.1);
      font-weight: bold;
      white-space: nowrap;
      z-index: 1000;
      pointer-events: none;
      user-select: none;
      width: 100vw;
      text-align: center;
  ">
      ${watermarkText}
  </div>
  ${html}
`;
